import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A component that restores the browser's scroll position to the top of the page.
 * For reference: https://v5.reactrouter.com/web/guides/scroll-restoration/scroll-to-top
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
